import apiClient from './axiosConfig';
import { API_ENDPOINTS } from '../constants';

const blogApi = {
  getBlogs: async ({ page = 1, perPage = 10, search = '', includeTrashed = false } = {}) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.BLOGS}`, {
        params: { page, per_page: perPage, search, trashed: includeTrashed ? 'true' : 'false' },
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching blogs:', error);
      throw error;
    }
  },

  getBlogByIdentifier: async (identifier) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.BLOGS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching blog ${identifier}:`, error);
      throw error;
    }
  },

  createBlog: async (blogData) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.BLOGS}`, blogData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating blog:', error);
      throw error;
    }
  },

  updateBlog: async (identifier, blogData) => {
    try {
      blogData.append('_method', 'PUT');
      const response = await apiClient.post(`${API_ENDPOINTS.BLOGS}/${identifier}`, blogData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating blog ${identifier}:`, error);
      throw error;
    }
  },

  trashBlog: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.BLOGS}/${identifier}`);
      return response.data;
    } catch (error) {
      console.error(`Error trashing blog ${identifier}:`, error);
      throw error;
    }
  },

  restoreBlog: async (identifier) => {
    try {
      const response = await apiClient.post(`${API_ENDPOINTS.BLOGS}/${identifier}/restore`);
      return response.data;
    } catch (error) {
      console.error(`Error restoring blog ${identifier}:`, error);
      throw error;
    }
  },

  permanentDeleteBlog: async (identifier) => {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.BLOGS}/${identifier}/permanent-delete`);
      return response.data;
    } catch (error) {
      console.error(`Error permanently deleting blog ${identifier}:`, error);
      throw error;
    }
  },

  getCategoriesForBlog: async (blogId) => {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.BLOGS}/${blogId}/categories`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching categories for blog ${blogId}:`, error);
      throw error;
    }
  },
};

export default blogApi;